import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/layout/Header";
import Sidebar from "../../../components/layout/Sidebar";
import LoaderLin from "../../../components/layout/LoaderLin";
import Loader from "../../../components/layout/Loader";
import DealerOrdersChart from "../../../components/analytics/Charts/DealerOrdersChart";
import { AnnualSaleAnalAction } from "../../../redux/actions/AnalyticsActions";
import { ListDealerAction } from "../../../redux/actions/DealerAction";
import { toggleFullScreen } from "../../../components/layout/functions/layout";
import DealerSalesData from "../../../components/analytics/Charts/DealersSalesData";
import LineChart from "../../../components/analytics/sales/LineChart";
import MonthlySales from "../../../components/analytics/Charts/MonthlySalesTable";
import { Box, Tabs, Tab } from "@mui/material";
import ProductPaymentAnalytics from "../../../components/analytics/Charts/ProductPaymentAnalytics";
import CostAndInventoryUtilizationAnalytics from "../../../components/analytics/costandutilization/CostUtilizationAnalytics";

const CostAndUtilization = ({ nav }) => {
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userSignIn);
  const { error, userInfo } = userLogin;


  useEffect(() => {
    if (!userInfo) {
      navigate("/sign-in");
    }
    window.scrollTo(0, 0);
    toggleFullScreen((nav = { nav }));
  }, [userInfo, navigate]);


  return (
    <>
      <div className={nav.isSidebar}>
        <Header nav={nav} />
        <Sidebar nav={nav} />
        <main className="page-content">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Dashboard</div>
            <div className="ps-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="bx bx-home-alt" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sales Analytics
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <hr />
          
            <CostAndInventoryUtilizationAnalytics nav={nav} />
          {/* <div className="row"> */}
            {/* main */}
          {/* </div> */}
        </main>

        <div className="overlay nav-toggle-icon" />
        <a href="#" className="back-to-top">
          <i className="bx bxs-up-arrow-alt" />
        </a>
      </div>
    </>
  );
};

export default CostAndUtilization;
